import { createStore } from 'vuex'
import 'es6-promise/auto'
import axios from 'axios'
import EventService from '@/services/EventService.js'
import { useCookies } from "vue3-cookies";

const store = createStore({
  state () {
    return {
      user: null,

    }
  },
  mutations: {

  },
  actions: {

     

  },
  getters: {
   
  }
})

export default store
